import React, { Component } from "react";
import { connect } from "react-redux";
import { getServerPools, deleteServerPool, setServerPoolPageInfo } from "../../actions/actionServerPool";
import { Link } from "react-router-dom";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import { getLicenses } from "../../actions/actionSystemInfo";

const routes = [
    { name: "Home", path: "/userdashboard", isActive: false },
    { name: "ServerPools", path: "/serverPools", isActive: true }
];

class ServerPools extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            pages: 1,
            server_poolId: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteServerPoolAction = this.deleteServerPoolAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    componentDidMount() {
        this.props.getServerPools();
    }

    deleteConfirm(server_poolId) {
        this.setState({
            modal: !this.state.modal,
            server_poolId: server_poolId
        });
    }

    cancelDelete() {
        this.setState({ modal: !this.state.modal });
    }

    deleteServerPoolAction() {
        this.props.deleteServerPool(this.state.server_poolId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess() {
        const { deleteServerPoolErrorMessage } = this.props;
        if (deleteServerPoolErrorMessage) {
            NotificationManager.error(deleteServerPoolErrorMessage, "Delete Pool Failed", 3000);
        } else {
            NotificationManager.success("Successfully Deleted Pool", "Delete Pool", 3000);
            this.setState({ modal: false });
            this.props.getServerPools();
        }
    }

    handleDeleteError() {
        const { deleteServerPoolError } = this.props;
        if (deleteServerPoolError) {
            NotificationManager.error(deleteServerPoolError, "Failed to Delete Pool", 3000);
            this.props.history.push("/server_pools");
        } else {
            NotificationManager.error("Failed to Delete Pool", "Delete Pool", 3000);
            this.props.history.push("/server_pools");
        }
    }

    render() {
        if (this.props.getServerPoolsLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const { server_pools, license_info } = this.props;

        const columns = [
            {
                type: "text",
                name: "Name",
                accessor: "server_pool_name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Servers",
                accessor: "servers.length",
                filterable: false,
                sortable: true
            },
            {
                type: "text",
                name: "Type",
                accessor: "server_pool_type",
                filterable: false,
                sortable: true
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/view_server_pool/${item.server_pool_id}`);
                    break;

                case "edit":
                    this.props.history.push(`/update_server_pool/${item.server_pool_id}`);
                    break;

                case "delete":
                    this.deleteConfirm(item.server_pool_id);
                    break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes} />
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <div className="title-head">
                                    <i className="fa fa-object-group"></i> <strong>Pools</strong>
                                </div>
                                <Link className="pull-right add-btn" to={{ pathname: "/create_server_pool" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add
                                    </button>
                                </Link>

                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="server_pools"
                                    data={server_pools}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <div className="tw-flex tw-justify-between">
                            {license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('auto_scaling') >= 0 && (
                                <React.Fragment>
                                    <Link to={{ pathname: "/autoscale" }}>All AutoScale Configs</Link>
                                    <Link to={{ pathname: "/vm_provider" }}>All VM Provider Configs</Link>
                                    <Link to={{ pathname: "/dns_provider" }}>All DNS Provider Configs</Link>
                                </React.Fragment>
                            )}
                        </div>
                    </Col>
                </Row>



                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this Pool?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm"
                            className="cancel-button"
                            color=" basic"> Close</Button>
                        <Button onClick={this.deleteServerPoolAction} size="sm"
                            className="delete-button"
                            color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

ServerPools.propTypes = {
    getServerPools: Proptypes.func.isRequired,
    deleteServerPool: Proptypes.func.isRequired,
    deleteServerPoolErrorMessage: Proptypes.func,
    deleteServerPoolError: Proptypes.func,
    history: Proptypes.object.isRequired,
    server_pools: Proptypes.array,
    createServerPoolLoading: Proptypes.bool,
    className: Proptypes.func
};


export default connect(state => ({
    server_pools: state.server_pools.server_pools || [],
    license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
    createServerPoolLoading: state.server_pools.createServerPoolLoading || false,
    deleteServerPoolErrorMessage: state.server_pools.deleteServerPoolErrorMessage || null,
    deleteServerPoolLoading: state.server_pools.deleteServerPoolLoading || false,
    deleteServerPoolError: state.server_pools.deleteServerPoolError || null,
    getServerPoolsLoading: state.server_pools.getServerPoolsLoading || null,
    pages: { pageSize: state.server_pools.pageSize, pageNo: state.server_pools.pageNo },
}),
    dispatch => ({
        getServerPools: () => dispatch(getServerPools()),
        getLicenses: () => dispatch(getLicenses()),
        deleteServerPool: (data) => dispatch(deleteServerPool(data)),
        setPageInfo: (data) => dispatch(setServerPoolPageInfo(data)),
    }))(ServerPools);